import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  startLoadingChart,
  setChartData,
  setChartError,
  setChartFilter,
} from "../store/dashboard";
import { gosafeApi } from "../api";

export const useDashboardStore = () => {
  // Datos del hook ----------------------------------------//
  const dispatch = useDispatch();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const getDataNumberOf = useCallback(
    async (chartId, apiUrl) => {
      try {
        dispatch(startLoadingChart(chartId));
        const { data } = await gosafeApi.get(`chart/${apiUrl}`);
        dispatch(setChartData({ chartId, data: data[chartId] }));
      } catch (error) {
        return dispatch(
          setChartError({ chartId, errorMessage: error.response.data.message })
        );
      }
    },
    [dispatch]
  );

  const getDataGroupedBySurgeryRoomsNox = useCallback(async () => {
    const chartId = `groupedBySurgeryRoomsNox`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/groupedBySurgeryRoomsNox?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      return dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const getDataNumberOfUsersByRole = useCallback(async () => {
    const chartId = `numberOfUsersByRole`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(`chart/byNumberOfUsersByRole`);

      const numberOfUsersByRole = {
        series: data.numberOfUsersByRole.series,
        chart: {
          width: 380,
          type: "pie",
        },
        labels: data.numberOfUsersByRole.labels,
        legend: {
          position: "top",
        },
        colors: ["#53c797", "#4493f9", "#f1b561"],
      };

      dispatch(setChartData({ chartId, data: numberOfUsersByRole }));
    } catch (error) {
      return dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const getDataEventsByAvailabilityProcedures = useCallback(async () => {
    const chartId = `eventsByAvailabilityProcedures`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/eventsByAvailabilityProcedures?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      return dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const getDataEventsByAvailabilityValorations = useCallback(async () => {
    const chartId = `eventsByAvailabilityValorations`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/eventsByAvailabilityValorations?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      return dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const getDataAverageSchedulingCompletion = useCallback(async () => {
    const chartId = `averageSchedulingCompletion`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/averageSchedulingCompletion?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      return dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const getDataPatientRepeatRegistrations = useCallback(async () => {
    const chartId = `patientRepeatRegistrations`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/patientRepeatRegistrations?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      setChartError({ chartId, errorMessage: error.response.data.message });
    }
  }, [dispatch]);

  const getDataProcedureCancellations = useCallback(async () => {
    const chartId = `procedureCancellations`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/procedureCancellations?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      setChartError({ chartId, errorMessage: error.response.data.message });
    }
  }, [dispatch]);

  const getDataValorationCancellations = useCallback(async () => {
    const chartId = `valorationCancellations`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/valorationCancellations?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      setChartError({ chartId, errorMessage: error.response.data.message });
    }
  }, [dispatch]);

  const getDataHyperbaricChamberSessions = useCallback(async () => {
    const chartId = `hyperbaricChamberSessions`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/hyperbaricChamberSessions?year=2025`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      setChartError({ chartId, errorMessage: error.response.data.message });
    }
  }, [dispatch]);

  const getDataPatientSurgeryByTrack = useCallback(async (filters) => {
    const chartId = `patientSurgeryByTrack`;
    try {
      dispatch(startLoadingChart(chartId));
      const { data } = await gosafeApi.get(
        `chart/patientSurgeryByTrack?procedureId=${filters.procedureId}&year=${filters.year}`
      );
      dispatch(setChartData({ chartId, data }));
    } catch (error) {
      dispatch(
        setChartError({ chartId, errorMessage: error.response.data.message })
      );
    }
  }, [dispatch]);

  const setChartFilterAction = useCallback((chartId, filterKey, filterValue) => {
    dispatch(setChartFilter({ chartId, filterKey, filterValue }));
  }, [dispatch]);

  // Efectos -----------------------------------------------//
  return {
    getDataNumberOf,
    getDataGroupedBySurgeryRoomsNox,
    getDataNumberOfUsersByRole,
    getDataEventsByAvailabilityProcedures,
    getDataEventsByAvailabilityValorations,
    getDataAverageSchedulingCompletion,
    getDataPatientRepeatRegistrations,
    getDataProcedureCancellations,
    getDataValorationCancellations,
    getDataHyperbaricChamberSessions,
    getDataPatientSurgeryByTrack,
    setChartFilterAction,
  };
};
